/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class AnnouncementListController {
    public static $inject = [
        '$scope',
        '$http',
        '$uibModal',
        '$state',
        'Announcement',
        'User',
        'toaster',
        'Calendar',
        'Process',
        'Employee',
        'bsLoadingOverlayService',
        'Orgs',
    ];

    public announcements;
    public user;
    public hasPermission;
    public schema;
    public titles;
    public processList;
    public birthdays;
    public meetings = [];
    public leavesToday;
    public today;
    public expiries = [];
    public depExpiries = [];
    public docExpiries = [];
    public canAnnounce = false;
    public eventCounts;
    public showTime;
    public employee;

    public editing = false;

    public isHelping = false;
    public showOverlayCallOuts = false;

    public tabSelect = 'Employees';

    public isTour;

    // callouts
    public isCurrent = -1;
    

    constructor(private $scope: any,
                private $http: ng.IHttpService,
                private $uibModal: any,
                private $state: ng.ui.IStateService,
                private Announcement: IAnnouncementService,
                private User: IUserService,
                private toaster: any,
                private Calendar: ICalendarService,
                private Process: IProcessService,
                private Employee: IEmpService,
                private bsLoadingOverlayService: IBsLoadingService,
                private Orgs: IOrgsService) {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;        
        
        this.user = User.getUserId();
        
        Announcement.loadAnounces().then(() => {
            this.announcements = this.Announcement.getAnnounces();

        }, () => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('error', 'Server error', 'Announcments not loaded');
        });

        Calendar.getTodayCountEvents((_eventCounts) => {
            this.eventCounts = _eventCounts;
        });

        let today: string = moment().toISOString().slice(0, 10);

        /** 
         * FIXME: Update to get list
         * Process.getProcessList({type: 'leave', extra: {success: true}, extra__steps__start__start_date__as_date__lte: today, extra__steps__start__end_date__as_date__gte: today}, -1).then((response: any) => { 
         *      this.processList = response;
         * });
         */ 
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.Employee.getWhoHaveBirthdayInMonth((response) => {
            this.birthdays = response.results;

            // sort birthdays by month and day
            this.birthdays.sort((leftSide: any, rightSide: any): number => {
                let leftBirthDate: any = leftSide.extra.personal.birth_date.substring(5);
                let rightBirthDate: any = rightSide.extra.personal.birth_date.substring(5);
                if (leftBirthDate < rightBirthDate) { return -1; }
                if (leftBirthDate > rightBirthDate) { return 1; }
                return 0;
            });
        });
        
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.Calendar.loadEvents(moment().startOf('day').unix(), moment().endOf('day').unix(), '', true).then((response) => {
            for (let i: number = 0; i < response.length; i++) {
                if (response[i].calendar_type !== 'leaves') {
                    this.meetings.push(response[i]);
                }
            }
            for (let j: number = 0; j < this.meetings.length; j++) {
                if (this.meetings[j].start !== undefined) {
                    this.meetings[j].start = new Date(this.meetings[j].start);
                    this.meetings[j].end = new Date(this.meetings[j].end);
                    if ((this.meetings[j].end.getHours() - this.meetings[j].start.getHours()) === 0) {
                    this.meetings[j].start = 0;
                    }
                }
            }

        });

        $scope.$on('$destroy', () => {
            Announcement.clearService();
        });

        $http.get('/api/employees/on_leave_today').then((response) => {
            this.leavesToday = response.data;
        });

        $http.get('/api/employees/expiries').then((response) => {
            this.bsLoadingOverlayService.start({referenceId: 'loader'});
            let emps: any = response.data;
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            if (emps.length <= 0) {
                return;
            }
                
            // create array of expiring employee documents
            this.expiries = [].concat.apply([],
                emps.map(emp => emp.expiries.map(exp => ({
                        id: emp.id,
                        displayname: emp.displayname,
                        doc: exp
                    })
                ))
            );

           // create an array of expiring dependants documents
            this.depExpiries = [].concat.apply([],
                emps.map(emp => emp.dep_expiries.map(exp => ({
                        id: emp.id,
                        displayname: emp.displayname,
                        dependantName: exp.dependant_name || '',
                        relation: exp.relation || '',
                        doc: exp
                    })
                ))
            );

           // create an array of expiring business documents
            this.docExpiries = [].concat.apply([],
                emps.map(emp => emp.doc_expiries.map(exp => ({
                        id: emp.id,
                        docType: emp.docType,
                        docDesc: exp.docDesc || '',
                        doc: exp
                    })
                ))
            );

            // push the dependants return into the expiries array if they are not hrm
            if (!this.hasPermission('org.change_org')) {
                if (this.depExpiries.length > 0) {
                    for (let i: number = 0; i < this.depExpiries.length; i++) {
                        this.expiries.push(this.depExpiries[i]);
                    }
                }
            }
        });
        if (this.hasPermission('org.change_org') === true) {
            this.canAnnounce = true;
        } else if (User.getCurrentUser().userData.subordinates.length > 0) {
            this.canAnnounce = true;
        }
        this.Orgs.getOrgFromCache((response) => {
            const officeDoc = response.extra.offices;
            const expiryStartDate = new Date();
            let expiryEndDate = new Date(expiryStartDate); 
            expiryEndDate.setDate(expiryEndDate.getDate() + 60);
            for (const off of officeDoc) {
                for (const offKey in off){
                    const valOff:any = off[offKey];
                    if (typeof valOff === 'object') {
                        for (const element of valOff) {
                            for (const elKey in element){
                                if (elKey === 'expiry_date') {
                                    const valDate:any = element[elKey];
                                    const dateBetweenExpired = new Date(valDate) > expiryStartDate && new Date(valDate) < expiryEndDate;
                                    const dateBeforeExpired = new Date(valDate) < expiryStartDate;
                                    if (dateBeforeExpired || dateBetweenExpired) {
                                        this.docExpiries.push({
                                            office: off.name,
                                            department: offKey,
                                            document: element.name || element.title,
                                            expiry_date: valDate
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
            
        this.Employee.loadEmployee(User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.isTour = this.Employee.getCoTourStatus();
            let hasVisited: Boolean = false;
            this.employee = response;
            let list: any = this.employee.extra.help_boxes_visited;
            if (!list) {
                list = [];
            }

            for (var i: any = 0; i < list.length; i++) {
                if (list[i] === 1) {
                    hasVisited = true;
                }
            }
            if (!hasVisited) {
                this.startCallouts();
            } else if (this.isTour === true) {
                this.startCallouts();
            }
        });

        $scope.$emit('$announcementsViewVisit');
        $scope.$emit('$pageWithHelpVisited', 1);

    }

    public selectProcess(process: any): void {
        if (process.leave_today.process) {
            this.$state.go('root.processes.detail', { id: process.leave_today.process });
        }
    }

    public showCreateModal(): void {
        let modalInstance: any = this.$uibModal.open({
            controller: 'CreateAnnouncementController as announcement',
            templateUrl: '/static/templates/modals/create_announcement.html'
        });

        modalInstance.result.then(() => {
            this.Announcement.loadAnounces().then(() => {
                this.announcements = this.Announcement.getAnnounces();
    
            }, () => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'Server error', 'Announcments not loaded');
            });
        });
    }

    public tabSelected(tab: any): any {
        this.tabSelect = tab;
    }

    public archiveAnnouncement(announcement: IAnnouncementElement, index: number): void {
        this.Announcement.moveAnnouncementToArchive(announcement, index);
    }

    public deleteModal(what: any, announcement: IAnnouncementElement): any {
        let that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function($scope: any, $uibModalInstance: any): any {
                $scope.C = that;
                $scope.what = what;
                $scope.obj = announcement;
            }],
            templateUrl: '/static/templates/organization/delete_modal.html'
        });
        modalInstance.result.then(() => {
            that.bsLoadingOverlayService.start({referenceId: 'requests_loader'});
            that.Announcement.dismissAnnounce(announcement).then(() => {
            that.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
            that.toaster.pop('success', 'Announcement deleted successfully');
            that.$scope.$emit('$EL', 'notification_board.del_announcement');
            that.announcements = that.announcements.filter((an) => {
                return an.id !== announcement.id;
                });
            }, () => {
                this.toaster.pop('error', 'Server error', 'Announcment cannot be deleted');
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
            });
        });

    }

    public nextCallout (params: any): any {
        
        if (this.canAnnounce === true && params === 'canAnnounce') {
        } else if (this.canAnnounce === false) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;   
        } else {
            this.isCurrent = this.isCurrent + 1;
        }
    } 

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public nextTour(): any {
        if (this.hasPermission('org.view_org')) {
            this.$state.go('root.org');
        } else {
            this.$state.go('root.employees');
        }
    }

    public routeToProfile(emp_id: any): void {
         this.$state.go('root.employees.details', { id: emp_id});
     }
}

angular.module('beneple.announcement')
    .controller('AnnouncementListController', AnnouncementListController);




// WEBPACK FOOTER //
// ./frontend/scripts/announcement/controllers/announcement_list.controller.ts